"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = exports.ClickableIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _ = require("./");
var _Text = require("../Text");
var _ClickableIconModule = _interopRequireDefault(require("./ClickableIcon.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ClickableIcon = exports.ClickableIcon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size = 'medium',
    ariaLabel,
    onClick,
    testId,
    // Deprecated for Clickable Icon
    className,
    classNames,
    disabled = false,
    ...props
  } = _ref;
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onClick?.(e);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnstyledButton, {
    ...props,
    type: "button",
    onClick: onClick,
    disabled: disabled,
    onKeyDown: onKeyDownHandler,
    ariaLabel: ariaLabel,
    className: (0, _classify.default)(_ClickableIconModule.default.button, {
      [_ClickableIconModule.default.small]: size === 'small',
      [_ClickableIconModule.default.medium]: size === 'medium',
      [_ClickableIconModule.default.large]: size === 'large'
    }, classNames?.button),
    ref: ref,
    testId: (0, _qa.generateTestId)({
      base: testId,
      slot: 'button'
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Icon, {
      ...props,
      size: size,
      color: disabled ? _Text.TEXT_COLORS.disabled : props.color,
      className: classNames?.icon || className,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'icon'
      })
    })
  });
});
const CloseIcon = exports.CloseIcon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    size = 'medium',
    type = 'regular',
    color = _Text.TEXT_COLORS.primary,
    testId,
    ...props
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ClickableIcon, {
    name: "close",
    size: size,
    type: type,
    color: color,
    testId: testId,
    ...props,
    ref: ref
  });
});